import debounce from 'lodash.debounce';
import { BREAKPOINT_MD } from 'utils/breakpoint';


const DEBOUNCE_VALUE = 50;

interface LanguageDropdownProps {
    el: HTMLScriptElement;
}


const LANGUAGE_DROPDOWN_TRIGGER_CLASSNAME = '.language-dropdown-trigger';
const LANGUAGE_DROPDOWN_MENU_CLASSNAME = '.language-dropdown-menu';
const LANGUAGE_DROPDOWN_TRIGGER_ACTIVE_CLASSNAME = 'is-open';
const LANGUAGE_DROPDOWN_MENU_ACTIVE_CLASSNAME = 'show';
const LANGUAGE_DROPDOWN_MENU_SHOW_TOP_CLASSNAME = 'show-top';

const LanguageDropdown = ({ el }: LanguageDropdownProps): void => {
    const trigger = el.querySelector(LANGUAGE_DROPDOWN_TRIGGER_CLASSNAME);
    const menu = el.querySelector(LANGUAGE_DROPDOWN_MENU_CLASSNAME);

    if (!trigger || !menu) {
        return;
    }

    const resetDropdown = (): void => {
        menu.classList.remove(LANGUAGE_DROPDOWN_MENU_ACTIVE_CLASSNAME);
        menu.classList.remove(LANGUAGE_DROPDOWN_MENU_SHOW_TOP_CLASSNAME);
        trigger.classList.remove(LANGUAGE_DROPDOWN_TRIGGER_ACTIVE_CLASSNAME);
    };

    trigger.addEventListener('click', () => {
        if (trigger.classList.contains(LANGUAGE_DROPDOWN_TRIGGER_ACTIVE_CLASSNAME)) {
            resetDropdown();
        } else {
            const dropdownRect = el.getBoundingClientRect();
            const menuRect = menu.getBoundingClientRect();
            // automatically change the position of the drop-down box depending on screen height on tablet and mobile
            const menuHeight = menuRect.height;
            const spaceFromBottom = window.innerHeight - dropdownRect.bottom;
            if (window.innerWidth <= BREAKPOINT_MD && menuHeight > spaceFromBottom) {
                menu.classList.add(LANGUAGE_DROPDOWN_MENU_SHOW_TOP_CLASSNAME);
            } else {
                menu.classList.add(LANGUAGE_DROPDOWN_MENU_ACTIVE_CLASSNAME);
            }
            trigger.classList.add(LANGUAGE_DROPDOWN_TRIGGER_ACTIVE_CLASSNAME);
        }
    });

    window.addEventListener('resize', debounce(resetDropdown, DEBOUNCE_VALUE));

    // if the user touches another part of the site, close the dropdown
    window.addEventListener('mouseup', e => {
        if (e.target && el !== e.target && !el.contains(e.target as HTMLElement) && !(e.target as HTMLElement).closest(LANGUAGE_DROPDOWN_TRIGGER_CLASSNAME)) {
            resetDropdown();
        }
    });
};

export default LanguageDropdown;
